<script>
    import { onMount } from "svelte";

    import FormRow from "./FormRow.svelte";
    import Checkbox from "./Checkbox.svelte";

    export let name = null;
    export let required = null;
    export let disabled = null;
   
    export let cols = "12";
    export let options = [];
    export let selectedOptions = [];
    export let validatorValue = 1;
    export let validatorMessage = "At least one selection required";

    let validator = null;
    let validatorTarget = null;
    let localOptions = [];

    const handleChange = (e) => {
        let index = selectedOptions.indexOf(e.target.value);
        if (e.target.checked) {
            if (index == -1) {
                selectedOptions.push(e.target.value);
            }
        } else {
            if (index > -1) {
                selectedOptions.splice(index, 1);
            }
        }
        selectedOptions = [...selectedOptions];
    }

    onMount(() => {
        // clone the options
        for (let i = 0; i < options.length; i++) {
            if (typeof {...options[i]} === 'object' && {...options[i]} !== null && !Array.isArray({...options[i]})) {
			    localOptions.push({...options[i]});
            } else {
			    localOptions.push({ label: options[i], value: options[i] });
            }
		}

        selectedOptions = selectedOptions || [];
   
        localOptions.forEach((o) => {
            o.checked = selectedOptions.indexOf(o.value) > -1;
        });
        localOptions = [...localOptions];

        if (required) {
            validator = "checkboxRequired";
            validatorTarget = ".checkbox-error";
        }
   })
    
</script>

<FormRow>
    {#each localOptions as option, i }
        <div class="col-md-{cols} form-inline checkbox-cell">
            <Checkbox {validator}
                    {validatorValue}
                    {validatorMessage}
                    {validatorTarget}
                    {disabled}
                    bind:checked="{option.checked}"
                    value="{option.value}"
                    label="{option.label}"
                    {name}
                    id="{name}{i}"
                    on:change={handleChange}></Checkbox>
        </div>
    {/each}
    <div class="checkbox-error"></div>
</FormRow>
<style>
    .checkbox-cell {
        height: 35px;
    }
</style>